/**
 * @generated SignedSource<<01ffa312f66a5f68fe212d455051dffd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SendTeamMemberInvitationInput = {
  accountId: string;
  email: string;
  message?: string | null;
};
export type teamMemberInvitationBulkSendMutation$variables = {
  input?: ReadonlyArray<SendTeamMemberInvitationInput> | null;
  connections: ReadonlyArray<string>;
};
export type teamMemberInvitationBulkSendMutation$data = {
  readonly sendTeamMemberInvitation: {
    readonly teamMemberInvitations: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"teamMemberInvitationFragment">;
    }>;
  };
};
export type teamMemberInvitationBulkSendMutation = {
  variables: teamMemberInvitationBulkSendMutation$variables;
  response: teamMemberInvitationBulkSendMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalRef",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  },
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "teamMemberInvitationBulkSendMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TeamMemberInvitationsPayload",
        "kind": "LinkedField",
        "name": "sendTeamMemberInvitation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamMemberInvitation",
            "kind": "LinkedField",
            "name": "teamMemberInvitations",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "teamMemberInvitationFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "teamMemberInvitationBulkSendMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TeamMemberInvitationsPayload",
        "kind": "LinkedField",
        "name": "sendTeamMemberInvitation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamMemberInvitation",
            "kind": "LinkedField",
            "name": "teamMemberInvitations",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Account",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "platformAccess",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "memberUserId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfile",
                "kind": "LinkedField",
                "name": "memberUserProfile",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accepted",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfile",
                "kind": "LinkedField",
                "name": "createdByUserProfile",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "teamMemberInvitations",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "Edge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "067c3484d23589c4e17d51d2a5bf0904",
    "id": null,
    "metadata": {},
    "name": "teamMemberInvitationBulkSendMutation",
    "operationKind": "mutation",
    "text": "mutation teamMemberInvitationBulkSendMutation(\n  $input: [SendTeamMemberInvitationInput!]\n) {\n  sendTeamMemberInvitation(input: $input) {\n    teamMemberInvitations {\n      ...teamMemberInvitationFragment\n      id\n    }\n  }\n}\n\nfragment accountBaseFragment on Account {\n  id\n  externalRef\n  name\n  platformAccess\n  createdAt\n}\n\nfragment teamMemberInvitationFragment on TeamMemberInvitation {\n  id\n  externalRef\n  accountId\n  account {\n    ...accountBaseFragment\n    id\n  }\n  memberUserId\n  memberUserProfile {\n    ...teamMemberUserProfileFragment\n    id\n  }\n  email\n  message\n  accepted\n  createdAt\n  createdByUserProfile {\n    ...teamMemberUserProfileFragment\n    id\n  }\n}\n\nfragment teamMemberUserProfileFragment on UserProfile {\n  firstName\n  lastName\n}\n"
  }
};
})();

(node as any).hash = "717276ee12f9dd0641f5e123fe28fc7a";

export default node;
